<sc-flex fitHeight stretchContent vertical>
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-common.ui.lpr-failures-action-item.picture-details-dialog-title"></sc-dictionary-label>
  </sc-dialog-title>
  <sc-flex-fitting-content vertical>
    <sc-padding fitHeight>
        <ac-resource-image-view [resourceId]="resourceId" withControls [allowDelete]="false"></ac-resource-image-view>
    </sc-padding>
  </sc-flex-fitting-content>
  <sc-padding class ="no-field-space">
    <sc-flex [formGroup]="formGroup" >
      <sc-content-spacer grow></sc-content-spacer>
      <sc-string-field labelDictionaryKey="tmc-common.ui.lpr-failures-action-item.picture-details-dialog-numberplate" formControlName="numberplate"></sc-string-field>
      <sc-content-spacer></sc-content-spacer>
      <sc-cancel-button (click)="cancel()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-confirm-button buttonStyle="flat" (click)="confirm()" [disabled]="!confirmAllowed"></sc-confirm-button>
    </sc-flex>
  </sc-padding>
</sc-flex>
